import { render, staticRenderFns } from "./chooseLocation.vue?vue&type=template&id=65494704&scoped=true"
import script from "./chooseLocation.vue?vue&type=script&lang=js"
export * from "./chooseLocation.vue?vue&type=script&lang=js"
import style0 from "./chooseLocation.vue?vue&type=style&index=0&id=65494704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65494704",
  null
  
)

export default component.exports